import React from "react";
import { Mail, Rocket,ArrowBigLeft } from "lucide-react";
import SEO from "../components/SEO";

const ComingSoon: React.FC = () => {
  return (
    <>
      <SEO
        title="Coming Soon | TheCodeBazaar"
        description="Something amazing is coming soon at TheCodeBazaar. Premium website themes, digital products and services."
        noIndex
      />

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-500 via-blue-600 to-indigo-700 relative overflow-hidden px-4">
        
        {/* Background glow blobs */}
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl" />

        {/* Card */}
        <div className="relative z-10 max-w-xl w-full backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl shadow-2xl p-8 md:p-12 text-center text-white">
          
          {/* Icon */}
          <div className="mx-auto mb-6 w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center">
            <Rocket className="w-8 h-8 text-white" />
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight">
            Coming Soon 🚀
          </h1>

          <p className="text-white/90 text-lg md:text-xl mb-8">
            We’re building something <span className="font-semibold">powerful</span>,{" "}
            <span className="font-semibold">premium</span> &{" "}
            <span className="font-semibold">worth the wait</span>.
          </p>

          {/* Notify form (UI only) */}
          {/* <form
            onSubmit={(e) => e.preventDefault()}
            className="flex flex-col sm:flex-row gap-3 mb-6"
          >
            <div className="relative flex-1">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/60" />
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full pl-11 pr-4 py-3 rounded-xl bg-white/20 placeholder-white/60 text-white focus:outline-none focus:ring-2 focus:ring-white/50"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 rounded-xl bg-white text-blue-600 font-semibold hover:bg-gray-100 transition"
            >
              Notify Me
            </button>
          </form> */}
<a href="/"
              className="inline-flex gap-2 px-6 mb-6 py-3 rounded-xl bg-white text-blue-600 font-semibold hover:bg-gray-100 transition"
            >
              <ArrowBigLeft/>
              Back to Home
            </a>

          {/* Footer text */}
          <p className="text-sm text-white/70">
            Premium Themes • Digital Products • Web Services
          </p>

          <p className="text-xs text-white/50 mt-2">
            © {new Date().getFullYear()} TheCodeBazaar.com
          </p>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
